import styled from "styled-components";
import ArrowBase from "./ArrowBase";

const ArrowDown = styled(ArrowBase)`
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid black;
`;

export default ArrowDown;
